module.exports = __webpack_public_path__ + "img/22_70.3dfaf826.png";